<template>
  <transition
    enter-from-class="opacity-0"
    enter-active-class="transition-opacity duration-[150ms] ease-in-out"
    leave-active-class="transition-opacity duration-[150ms] ease-in-out"
    leave-to-class="opacity-0"
  >
    <div
      v-show="spinnerStore.isVisible"
      class="fixed top-0 left-0 w-full h-full bg-black bg-opacity-70 flex items-center justify-center z-100 dark"
    >
      <content-loading-spinner :text="spinnerStore.text" />
    </div>
  </transition>
</template>

<script setup lang="ts">
import ContentLoadingSpinner from '@serato/spinners/ContentLoadingSpinner.vue'
import { useSpinnerStore } from '@/stores/spinner-store'
import { watch } from 'vue'

const spinnerStore = useSpinnerStore()

watch(() => spinnerStore.isVisible, () => { // Disable scrolling when the overlay is open
  if (spinnerStore.isVisible) {
    document.body.classList.add('overflow-hidden')
  } else {
    document.body.classList.remove('overflow-hidden')
  }
})
</script>